<template>
    <div>
        <q-dialog v-model="show" maximized @input="(val) => $emit('input', val)">
            <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
                <q-header class="bg-primary">
                    <q-toolbar>
                        <q-toolbar-title>{{ $gettext('CREATE_NEW_CARRIER') }}</q-toolbar-title>
                        <q-btn v-close-popup flat round dense icon="close" />
                    </q-toolbar>
                </q-header>
                <q-page-container class="modal-content scroll">
                    <component
                        :id="pageData.id"
                        ref="dynamicForm"
                        :is="pageData.component"
                        :name="pageData.name"
                        :params="pageData.params"
                        :forms="pageData.forms"
                        :datatable="pageData.datatable"
                        :parent="pageData.parent"
                        :nmInterface="pageData.interface"
                        :interface="pageData.interface"
                        :controllerSearch="true"
                        @action-button="actionButton"
                        @show-message="showMessage"
                        class="client-container generator-client"
                        clean-layout
                    />
                </q-page-container>
            </q-layout>
        </q-dialog>
    </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import CollectionPointRegisterForm from './CollectionPointRegisterFormPage.vue'
const { modal } = JtCrud
import { repository, messageBox } from 'jtech'

@Component({
  mixins: [modal],
  name: 'collectionPointRegisterModal',
  components: { CollectionPointRegisterForm }
})
class CollectionPointRegisterModal extends Vue {
    pageData = {};

    created () {
      this.generateForm()
    }

    async generateForm () {
      const item = {
        name: 'COLLECTION_POINT',
        icon: 'pin_drop',
        interface: 'collectionPoint.registrarNovo',
        component: CollectionPointRegisterForm,
        title: 'COLLECTION_POINT_CLIENT',
        crud: false
      }

      const pageData = {}
      pageData.crud = item.crud
      if (!pageData.crud) {
        const forms = await repository.resolve(item.interface, this.params)
        pageData.forms = forms
      }
      pageData.component = item.component
      pageData.name = item.name
      pageData.id = item.name
      pageData.interface = item.interface
      pageData.params = {
        name: item.name,
        client: this.id
      }
      pageData.datatable = null
      pageData.title = item.title
      this.pageData = pageData
    }

    get _modal () {
      return CollectionPointRegisterForm
    }
}
export default CollectionPointRegisterModal
</script>
<style lang="stylus" scoped>
.modal-content {
  padding-top: 60px;
}
</style>
